import { render, staticRenderFns } from "./purchaseList.vue?vue&type=template&id=97a05d6a&scoped=true&"
import script from "./purchaseList.vue?vue&type=script&lang=js&"
export * from "./purchaseList.vue?vue&type=script&lang=js&"
import style0 from "./purchaseList.vue?vue&type=style&index=0&id=97a05d6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a05d6a",
  null
  
)

export default component.exports